import { useMemo } from "react";
import { WorkspaceMember } from "@common/types/workspace";
import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";
import { DescriptionListItem } from "@design-system/DescriptionList/DescriptionList";
import taskStyles from "@components/drawers/TaskDrawerFields.module.scss";

const NO_DEFAULT_ASSIGNEE_VALUE = "__no_default_assignee__";
const NO_DEFAULT_ASSIGNEE_LABEL = "None (use role)";

interface Props {
    members: WorkspaceMember[] | undefined;
    value: number | null;
    onChange: (value: number | null) => void;
}

export const DefaultAssigneeField = ({ members, value, onChange }: Props) => {
    const items = useMemo<Array<PickerItemData<string>>>(
        () => [
            {
                value: NO_DEFAULT_ASSIGNEE_VALUE,
                label: NO_DEFAULT_ASSIGNEE_LABEL,
            },
            ...(members ?? []).map((member) => ({
                value: String(member.user.id),
                label: member.user.name,
            })),
        ],
        [members],
    );
    const selectedMemberName = members?.find(
        (member) => member.user.id === value,
    )?.user.name;

    return (
        <DescriptionListItem label="Default assignee">
            <div className={taskStyles.detailSelectWrapper}>
                <Picker.Select
                    searchable
                    items={items}
                    value={value?.toString() ?? NO_DEFAULT_ASSIGNEE_VALUE}
                    onValueChange={(next) => {
                        onChange(
                            next === null || next === NO_DEFAULT_ASSIGNEE_VALUE
                                ? null
                                : Number(next),
                        );
                    }}
                    renderValue={() =>
                        selectedMemberName ?? NO_DEFAULT_ASSIGNEE_LABEL
                    }
                    trigger={
                        <Picker.Button
                            variant="primary"
                            className={taskStyles.detailSelectTrigger}
                        />
                    }
                />
            </div>
        </DescriptionListItem>
    );
};
